import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid, Pagination } from '../types';
import { infiniteQueryOptions } from '../utils';
import { Appendix4ApiForm, CommercialMeteringPoints } from './types';

const transformAppendix4ExportKeyResponse = (response: any) => {
  const id = typeof response === 'string' ? response : response?.id;

  return {
    link: `${Config.VITE_ANALYTICS_API_URL}/reports/counterparty-contract-appendix4/export/${id}`,
  };
};

export const appendix4Api = createApi({
  reducerPath: 'appendix4Api',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_ANALYTICS_API_URL}/reports/counterparty-contract-appendix4`,
  }),
  endpoints: builder => ({
    getAppendix4ExportKey: builder.mutation<{ link: string }, Appendix4ApiForm>(
      {
        query: body => ({
          url: `/export-key`,
          method: 'POST',
          data: body,
          meta: { body },
        }),
        transformResponse: transformAppendix4ExportKeyResponse,
      },
    ),
    getCommercialMeteringPointsI: builder.infiniteQuery<
      CommercialMeteringPoints[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/metering-points`,
        params: { ...queryArg, ...pageParam },
      }),
    }),
  }),
});

export const { useGetAppendix4ExportKeyMutation } = appendix4Api;
export const useGetCommercialMeteringPointsInfiniteQuery =
  normalizeInfiniteQueryData(
    appendix4Api.useGetCommercialMeteringPointsIInfiniteQuery,
  );
